import React from 'react'
import { Field as Input } from 'redux-form'
import _ from 'lodash'

import MenuItem from '@material-ui/core/MenuItem'

import {
    TextInput,
    CheckboxInput,
    ReferenceSelectInput,
    SelectInput,
    StatusSelectInput,
    ChoicesSelectInput,
    ValidadoSelectInput
} from '../Inputs'


const renderStringInput = (input) => (
    <Input
        key={input.source}
        name={input.source}
        type="text"
        label={input.label || input.source}
        required={!!input.required}
        component={TextInput}
        disabled={input.disabled}
    />
)

const renderEmailInput = (input) => (
    <Input
        key={input.source}
        name={input.source}
        type="email"
        label={input.label || input.source}
        required={!!input.required}
        component={TextInput}
        disabled={input.disabled}
    />
)

const renderNumberInput = (input) => (
    <Input
        key={input.source}
        name={input.source}
        type="number"
        label={input.label || input.source}
        required={!!input.required}
        component={TextInput}
        parse={(value, name) => Number(value)}
        disabled={input.disabled}
    />
)

const renderBooleanInput = (input) => (
    <Input
        key={input.source}
        name={input.source}
        label={input.label || input.source}
        component={CheckboxInput}
        disabled={input.disabled}
    />
)

const renderDateInput = (input) => (
    <Input
        key={input.source}
        name={input.source}
        type="date"
        label={input.label || input.source}
        required={!!input.required}
        component={TextInput}
        disabled={input.disabled}
    />
)

const renderSelectInput = (input) => (
    <Input
        key={input.source}
        name={input.source}
        label={input.label || input.source}
        required={!!input.required}
        component={SelectInput}
        disabled={input.disabled}
    >
        {_.map(input.choices, (choice, index) => (
            <MenuItem value={choice[input.optionValue]} key={index}>
                {choice[input.optionText]}
            </MenuItem>
        ))}
    </Input>
)

const renderRelatedInput = (input, multi=false) => (
    <Input
        key={input.source}
        name={input.source}
        label={input.label || input.source}
        required={!!input.required}
        component={ReferenceSelectInput}
        reference={input.reference}
        optionText={input.targetSource}
        isDisabled={input.disabled}
        isMulti={multi}
    />
)

const renderNodeRelatedInput = (input) => {

  const label = input.allowed_nodes.length > 1 
    ? `${input.label} (${input.allowed_nodes.join(', ')})` 
    : `${input.label} ${input.allowed_nodes[0]}`

  const filter = {
    name__multi_startswith : input.allowed_nodes.join(',')
  }

  return (
    <Input
        key={input.source}
        name={input.source}
        label={label}
        required={!!input.required}
        component={ReferenceSelectInput}
        reference={input.reference}
        optionText={input.targetSource}
        isDisabled={input.disabled}
        filters={filter}
    />
  )
}

const renderChoicesSelectInput = (input) => (
    <Input
        key={input.source}
        name={input.source}
        label={input.label || input.source}
        required={!!input.required}
        component={ChoicesSelectInput}
        disabled={input.disabled}
        choices={input.choices}
    />
)

const renderStatusSelectInput = (input) => (
    <Input
        key={input.source}
        name={input.source}
        label={input.label || input.source}
        required={!!input.required}
        component={StatusSelectInput}
        optionText={input.targetSource}
        disabled={input.disabled}
    />
)

const renderValidadoSelectInput = (input) => (
  <Input
      key={input.source}
      name={input.source}
      label={input.label || input.source}
      required={!!input.required}
      component={ValidadoSelectInput}
      optionText={input.targetSource}
      disabled={input.disabled}
  />
)

const renderInput = (disabled, role) => (input) => {
  if(!input.disabled)
    input.disabled = disabled

  // TODO: Find a better way to do this
  if ((input.source === "ref_id" || input.source === 'description') && role === "coordinado"){
    input.disabled = false
  }

  switch (input.type) {
    case "string":
      return renderStringInput(input)
    case "email":
      return renderEmailInput(input)
    case "number":
      return renderNumberInput(input)
    case "boolean":
      return renderBooleanInput(input)
    case "date":
      return renderDateInput(input)
    case "select":
      return renderSelectInput(input)
    case "reference":
      return renderRelatedInput(input)
    case "referenceMany":
      return renderRelatedInput(input, true)
    case "nodeReference":
      return renderNodeRelatedInput(input)
    case "choices":
      return renderChoicesSelectInput(input)
    case "status":
      return renderStatusSelectInput(input)
    case "validado":
      return renderValidadoSelectInput(input)
    default:
      return null
  }
}


export const renderModelInputs = (inputs, role) => {
  const disabled = !["admin", "coordinador"].includes(role)
  return _.map(inputs, renderInput(disabled, role))
}
